export const BULLETIN_KIND = {
	contact_recruiter: 'contact_recruiter',
	referral: 'referral',
	job_apply_process: 'job_apply_process',
	job_apply_process_inside_usa: 'job_apply_process_inside_usa',
	job_apply_process_outside_usa: 'job_apply_process_outside_usa',
	contact_support: 'contact_support',
}
